import Button from "devextreme-react/button";
import ContextMenu, { Position } from "devextreme-react/context-menu";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { QuoteStatus, QuoteTypes } from "../../../../types/enums";
import { EstimateContext } from "../context/EstimateContext";

export default function CreateRevisionButton() {

	const { order } = useContext(EstimateContext);
	const navigate = useNavigate();

	return (
		<>
			<Button
				id="create-revision-button"
				visible={order.details.imeStatus !== 'SALE' && order.details.statusID === QuoteStatus.Open &&
					order.details.quoteTypeID !== QuoteTypes.Lead}
				onClick={() => {
					if (order.details.quoteTypeID === QuoteTypes.WinApp) {
						alert("Estimate was edited by Sage Support team and can no longer be accessed through the estimator tools");
					}
					else if (order.details.quoteTypeID === QuoteTypes.EasyEstimator || order.details.quoteTypeID === QuoteTypes.EESync) {
						navigate('/dealer/easy-estimator-old/' + order.details.quoteID);
					}
					else if (order.details.quoteTypeID === QuoteTypes.EasyEstimator3) {
						window.open(order.details.easyEstimatorUrl3 + '?loadEstimate=' + order.details.guid);
					}
					else {
						window.open(order.details.easyEstimatorUrl + '?loadEstimate=' + order.details.guid);
					}
				}}
			>
				<i className="dx-icon dx-icon-Inscyth-Easy-Estimator"></i>
				Create Revision
			</Button>
		</>
	)
}
